<template>
  <v-navigation-drawer
      v-if="$vuetify.breakpoint.smAndUp"
      id="documentation-toc"
      v-scroll="onScroll"
      width="200"
      style="min-width: 180px"
      class="tw-ml-4 md:tw-ml-8"
      right
      permanent
  >
    <template>
      <ul class="pt-8 mb-6 documentation-toc">
        <li class="mb-4">
          <h3 class="caption font-weight-bold text-uppercase grey--text">
            On This Page
          </h3>
        </li>

        <template v-for="(item, i) in internalToc">
          <li
              :key="i"
              :class="{
              'documentation-toc__link--subheader': item.subheader,
              'mb-4': i + 1 !== internalToc.length,
              'primary--text': activeIndex === i,
              'tw-text-gray-700': activeIndex !== i
            }"
              :style="{
              borderColor: activeIndex === i ? 'currentColor' : undefined
            }"
              class="documentation-toc__link"
          >
            <a
                :href="`#${item.id}`"
                class="d-block font-weight-medium"
                @click.stop.prevent="goTo(item, i)"
                v-html="item.text"
            />
          </li>
        </template>
      </ul>

    </template>
  </v-navigation-drawer>
  <v-menu v-else
          v-scroll="onScroll"
  >
    <template v-slot:activator="{ on }">
      <v-toolbar height="36" class="tw-fixed tw-bottom-0 tw-left-0 tw-z-30 tw-w-full" v-on="on" style="margin-top: 56px">
        <v-toolbar-title class="text-subtitle-2">
          {{ internalToc[activeIndex] ? internalToc[activeIndex].text : 'Page Content' }}
        </v-toolbar-title>
      </v-toolbar>
    </template>
    <v-sheet>
      <v-list dense>
        <v-list-item v-for="(item, i) in internalToc" :key="i" @click="$vuetify.goTo(`#${item.id}`)">
          <v-list-item-title
              :key="i"
              :class="{
              'primary--text': activeIndex === i,
              'text--disabled': activeIndex !== i
            }"
          >
            {{ item.text }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-sheet>
  </v-menu>
</template>

<script>
// Utilities
export default {
  name: 'TableOfContent',
  props: {
    offset: {
      type: Number,
      default: -100
    },
    toc: {
      type: Array,
      required: true
    }
  },
  computed: {
    calculatedToc () {
      if (this._.isObject(this.toc[0])) {
        return this.toc
      } else {
        const output = []
        this.toc.forEach(item => {
          output.push({
            id: this._.camelCase(item),
            text: item
          })
        })
        return output
      }
    }
  },
  data () {
    return {
      activeIndex: 0,
      currentOffset: 0,
      internalToc: [],
      tocTimeout: 0,
      hardStop: false,
      stopClick: false
    }
  },

  watch: {
    calculatedToc: {
      immediate: true,
      handler (val) {
        if (!val.length) return
        this.$nextTick(() => (this.internalToc = this.calculatedToc.slice()))
      }
    }
  },

  methods: {
    goTo (item, index) {
      if (!this.stopClick) {
        this.stopClick = true
        this.hardStop = true
        this.activeIndex = index
        this.$vuetify.goTo(`#${item.id}`)
        setTimeout(() => {
          this.stopClick = false
        }, 1500)
      }
    },
    findActiveIndex () {
      if (this.currentOffset < 100) {
        this.activeIndex = 0
        return
      }

      const list = this.calculatedToc.slice().reverse()
      const index = list.findIndex((item, index) => {
        const section = document.getElementById(item.id)
        // console.log(item.id, index, section.offsetTop, section.offsetTop + window.innerHeight, this.currentOffset, section.offsetTop + (parseInt(index) === list.length - 1 ? 0 : this.offset) < this.currentOffset)
        if (!section) return false
        return section.offsetTop + (parseInt(index) === list.length - 1 ? 0 : this.offset) < this.currentOffset
      })

      const lastIndex = list.length - 1

      if (!this.hardStop) {
        console.log('change')
        this.activeIndex = index > -1
          ? lastIndex - index
          : 0
      }
    },
    onScroll () {
      if (this.hardStop) {
        setTimeout(() => {
          console.log('can scroll')
          this.hardStop = false
        }, 1000)
      }
      this.currentOffset = (
        window.pageYOffset ||
        document.documentElement.offsetTop ||
        0
      )

      // console.log(Math.round(this.currentOffset, 0))

      clearTimeout(this.timeout)

      this.timeout = setTimeout(this.findActiveIndex, 50)
    }
  }
}
</script>

<style lang="sass">
  #documentation-toc
    .supporter-group__title
      padding-left: 8px

    .documentation-toc
      list-style-type: none !important
      margin: 0
      padding: 32px 0 0
      text-align: left
      width: 100%

      li
        border-left: 2px solid transparent
        padding: 0 24px 0 8px

      li a
        color: inherit
        font-size: .875rem
        font-weight: 400
        text-decoration: none
        transition: color .1s ease-in

      .supporter-group
        justify-content: flex-start !important

      .documentation-toc__link--subheader
        margin-left: 8px
</style>
